// @flow
import { DragDropContext } from 'react-dnd';
import DragDropBackend from 'react-dnd-html5-backend';

// TODO(yansun): move this into some global context?
export default DragDropContext(DragDropBackend);
